import { alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Avatar(theme) {
  return {
    MuiAvatar: {
      styleOverrides: {
        colorDefault: {
          color: theme.palette.mode === 'light' ? theme.palette.text.secondary : theme.palette.common.white,
          backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
          fontWeight: 600,
        }
      }
    },
    MuiAvatarGroup: {
      styleOverrides: {
        avatar: {
          fontSize: 16,
          fontWeight: theme.typography.fontWeightMedium,
          '&:first-of-type': {
            fontSize: 14,
            color: theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.primary.contrastText,
            backgroundColor: theme.palette.mode === 'light' ? theme.palette.primary.lighter : theme.palette.primary.main
          }
        }
      }
    }
  };
}
